  import { combineReducers } from 'redux';

import posts from './reducer-posts';
import postType from './reducer-postType';
import featured from './reducer-featured';
import view from './reducer-view';
import dateRange from './reducer-dates';
import pagination from './reducer-pagination';
import searchTerm from './reducer-search';
import categories from './reducer-categories';
import catSource from './reducer-categorySource';
import selectedCategory from './reducer-selectedCategory';
import loading from './reducer-loading';
export default combineReducers( {
	                                posts,
	                                postType,
	                                featured,
	                                view,
	                                dateRange,
	                                pagination,
	                                searchTerm,
	                                categories,
	                                catSource,
	                                selectedCategory,
	                                loading
                                } );